<script>
    export let fill = '#FFF'
</script>

<style>
    svg#event-info-tab-bar {
        position: absolute;
        width: 414px;
        height: 50px;
        left: 0;
        top: 229px;
    }
</style>

<svg id="event-info-tab-bar" x="0px" y="0px" viewBox="0 0 414 50">
	<g id="topbar">
		<rect {fill} width="414" height="50"/>
	</g>
</svg>
